import { render, staticRenderFns } from "./esgManagementData.vue?vue&type=template&id=3ccdf248"
import script from "./esgManagementData.vue?vue&type=script&lang=js"
export * from "./esgManagementData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ccdf248')) {
      api.createRecord('3ccdf248', component.options)
    } else {
      api.reload('3ccdf248', component.options)
    }
    module.hot.accept("./esgManagementData.vue?vue&type=template&id=3ccdf248", function () {
      api.rerender('3ccdf248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/esg/esgManagementData.vue"
export default component.exports